import type React from 'react';
import type { AppSsrFetchedDataType } from '../../../server/AppSsr';
import CategoriesBar from '../CategoriesBar';
import Footer from '../Footer';
import Navbar from '../Navbar';

interface MainLayoutProps {
  ssrFetchedData: AppSsrFetchedDataType;
  customSize?: number;
  categories: boolean;
  search: boolean;
  navbar: boolean;
  footer: boolean;
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({
  customSize,
  categories,
  children,
  search,
  navbar,
  footer,
  ssrFetchedData,
}) => (
  <div className="flex min-h-[calc(100dvh)] flex-col">
    <div className="flex grow flex-col items-center justify-center">
      <div
        className={`flex w-full grow ${
          customSize ? `max-w-[${customSize}px]` : 'max-w-screen-2xl'
        } flex-col`}
      >
        <div className="sticky top-0 z-40 flex w-full flex-col border-0 bg-white">
          {navbar && <Navbar withSearch={search} />}
          {categories && <CategoriesBar />}
        </div>
        <div className="flex min-h-full w-full grow flex-col">{children}</div>
        {footer && (
          <div className="flex min-w-full border-0">
            <Footer ssrFetchedData={ssrFetchedData} />
          </div>
        )}
      </div>
    </div>
  </div>
);

export default MainLayout;
